/* eslint-disable @typescript-eslint/no-floating-promises */
import { toast } from 'react-toastify'
import { cleanObject, getErrorMessage } from '../../helpers'
import { BaseApiResponse, QueryProps } from '../shared/shared.type'
import { apiSlice } from '../api/apiSlice'
import { ErrorType } from '../shared/shared.type'
import {
  GetRatingsResponse,
  GetSettlementConfigResponse,
  SettlementConfig,
} from './settings.type'

export const settingsApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAllRatings: builder.query<GetRatingsResponse, QueryProps>({
      query: (params) => {
        const updatedParams = cleanObject(params)
        return {
          url: `v2/ratings`,
          params: {
            ...updatedParams,
          },
          method: 'GET',
        }
      },
      providesTags: [{ type: 'RATING', id: 'LIST' }],
    }),

    getSettlementConfig: builder.query<GetSettlementConfigResponse, void>({
      query: (payload) => ({
        url: `v1/system-settings/SETTLEMENT`,
        method: 'GET',
      }),
      providesTags: ['SETTLEMENT'],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (error) {
          toast.error(getErrorMessage(error as ErrorType))
        }
      },
    }),

    updateSettlementConfig: builder.mutation<BaseApiResponse, SettlementConfig>(
      {
        query: (payload) => ({
          url: `v1/system-settings/SETTLEMENT`,
          method: 'PUT',
          body: payload,
        }),
        invalidatesTags: ['SETTLEMENT'],
        async onQueryStarted(arg, { queryFulfilled }) {
          try {
            const data = await queryFulfilled
            toast.success(data.data.message)
          } catch (error) {
            toast.error(getErrorMessage(error as ErrorType))
          }
        },
      },
    ),
  }),
})

export const {
  useGetSettlementConfigQuery,
  useGetAllRatingsQuery,
  useUpdateSettlementConfigMutation,
} = settingsApiSlice
